module.exports = __webpack_public_path__ + "media/components/assets/icons/rank/top4-080e206fa98e1df28c5fec305f3ea490.svg";